import Model, { attr, belongsTo } from '@ember-data/model';
import type FamilyModel from './family.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class FamilyInviteModel extends Model {
  @attr declare inviteCodeTypeId: string;
  @attr declare isActive: boolean;
  // @ts-expect-error: most likely a bug
  @attr declare isValid: boolean;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('family', { async: false, inverse: 'family' })
  declare family: FamilyModel;

  [Type] = 'family-invite' as const;
}
